import React, { useState, useEffect } from 'react'
import Tabla from '../../components/Tabla'
import useUser from '../../hooks/useUser'
import { useNavigate, Link  } from 'react-router-dom'
import { getPermisosEnPagina, getBasePath, getAuth } from '../../Utils'
import SinPermisos from '../SinPermisos'
import axios from "axios"
import eliminarRegistro from '../../components/eliminarRegistro'
import { JsonToExcel } from "react-json-to-excel"

const columns = [
    {
        name: 'Num. Factura',
        selector: row => row.numero,
        sortable: true,
    },
    {
        name: 'Fecha',
        selector: row => row.fechaMostrar,
        sortable: true,
    },
    {
        name: 'Base imponible',
        selector: row => row.precio,
        sortable: true,
    },
    {
        name: 'IVA',
        selector: row => row.iva,
        sortable: true,
    },
    {
        name: 'Total',
        selector: row => row.importe,
        sortable: true,
    },
    {
        name: '',
        selector: row => row.editar,
        sortable: false,
        width: "75px",
        margin: "0"
    },
    {
        name:<Link to='#' style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary" onClick={() => document.getElementsByClassName("download-button")[0].click()}><i className="ti ti-cloud-down"></i></Link>,
        selector: row => row.borar,
        sortable: false,
        width: "75px",
        margin: "0"
    }
];

const Facturas = () => {
    const {isLogged, permisosUsuario, hotelSelected} = useUser();
    const navigate = useNavigate();
    const permisos = getPermisosEnPagina(permisosUsuario, 'Facturas')
    const [data, setData] = useState([])
    const [excel, setExcel] = useState([])

    const cargarData = async () => {
        const {data: facturas} = await axios.get(`${getBasePath()}/devuelvefacturasporhotel/${hotelSelected}`, getAuth());
        let facturasExcel = []
        facturas.forEach(el =>  {
            //
            //Definimos los datos del excel
            //
            const facturasObj = {"Nombre": el.nombre}
            facturasExcel.push(facturasObj)
            //
            //Ahora definimos los botones
            //
            if(permisos.editar) 
                el.editar = (<div><Link to={`/facturasform/editar/${el.id}`} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-pencil"></i></Link></div>)
            if(permisos.borrar) 
                el.borar = (<div><Link to={`/facturas`} onClick={() => eliminarRegistro(el.id, 'facturas')} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-trash"></i></Link></div>)
            el.ver = (<div><Link to={`/facturasform/ver/${el.id}`} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-eye"></i></Link></div>)
        })
        setData(facturas)
        setExcel(facturasExcel)
    }

    useEffect(() => {
        cargarData()
    },[])

    useEffect(() => {
        if (!isLogged) { navigate("/login"); }
    }, [isLogged]);

    return isLogged && permisos.ver ? (<div>
        <div style={{display:"none"}}><JsonToExcel data={excel} fileName="Facturas" /></div>
        <div className="bgc-white p-20 bd" style={{ marginBottom: "10px" }}>
            <h6 className="c-grey-900">Facturas</h6>
            { permisos.crear &&
                <div className="mT-30">
                    <Link className="btn btn-success btn-color" to="/facturasform/nuevo">Nuevo</Link>
                </div>
            }
        </div>
        <Tabla columns={columns} data={data} selectableRows />
    </div>) : (<SinPermisos/>)
}

export default Facturas;